import React, { useState } from "react"
import { useShallow } from "zustand/react/shallow"

// components
import Modal from "components/Modal/Modal"
import RJCommentForm from "../RJCommentForm/RJCommentForm"
import RJCommentItem from "../RJCommentItem/RJCommentItem"
import { PrimeButton } from "components-design-system"

// hooks
import useAuthoringStore from "../../../hooks/stores/useAuthoringStore"
import { useUserPermissions } from "api/hooks"
import { useDeleteAuthoringComment } from "api/hooks/studies/useAuthoringApi"
import useAuthoringCommentsStore from "../../../hooks/stores/useAuthoringCommentsStore"
import scrollIntoViewIfNeeded from "utilities/scrollIntoViewIfNeeded"
import useOnClickOutside from "utilities/useOnClickOutside"
import useAuthoringViewStore from "../../../hooks/stores/useAuthoringViewStore"

// styles
import "./RJCommentList.scss"

const RJCommentList = ({ jpath, label, setOpenForm, setShowMenu, openForm }) => {
  const { formView, formSection } = useAuthoringViewStore(
    useShallow((state) => ({
      formView: state.formView,
      formSection: state.formSection,
    }))
  )
  const authoringId = useAuthoringStore((state) => state.authoringId)
  const ref = React.useRef()

  const { commentsMap, setOpenComment } = useAuthoringCommentsStore(
    useShallow((state) => ({
      commentsMap: state.commentsMap,
      setOpenComment: state.setOpenComment,
    }))
  )

  const { data: permissions } = useUserPermissions()
  const deleteAuthoringComment = useDeleteAuthoringComment(authoringId)

  const [editComment, setEditComment] = useState(null)
  const [deleteComment, setDeleteComment] = useState(null)
  const [showDelete, setShowDelete] = useState(false)

  React.useEffect(() => {
    if (openForm) {
      scrollIntoViewIfNeeded(ref)
    }
  }, [openForm])

  useOnClickOutside(ref, () => {
    setOpenForm(false)
    setOpenComment(null)
  })

  const handleDelete = (comment) => {
    setDeleteComment(comment)
    setShowDelete(true)
  }

  const onDeleteComment = () => {
    deleteAuthoringComment(
      { id: deleteComment.id + "/" },
      {
        onSuccess: () => {
          setShowMenu(false)
          setDeleteComment(null)
          setShowDelete(false)
        },
      }
    )
  }

  const commentsLength = commentsMap?.[jpath]?.length || 0
  const containerId = `rjs-comment-list-${jpath}`

  return (
    <div
      className="rjs-comment-list-container"
      id={containerId}
      ref={ref}
    >
      {commentsLength > 0 && (
        <div className="comment-list-container">
          {commentsMap?.[jpath]
            ?.filter((comment) => {
              if (comment.form_section && comment.form_view && formView?.id !== "global") {
                // if form section and view matches then render the comment
                if (comment.form_section === formSection.id && comment.form_view === formView?.id) {
                  return true
                } else {
                  return false
                }
              }

              return true
            })
            .map((comment, i) => {
              return (
                <RJCommentItem
                  key={comment?.id + comment?.text}
                  index={i}
                  handleEdit={setEditComment}
                  handleDelete={handleDelete}
                  comment={comment}
                />
              )
            })}
        </div>
      )}
      {permissions["study.authoringcomment.create"] && (
        <RJCommentForm
          jpath={jpath}
          label={label}
          editComment={editComment}
          setEditComment={setEditComment}
          setShowMenu={setShowMenu}
          setOpenForm={setOpenForm}
        />
      )}

      <Modal
        title={"Delete Comment"}
        message={"Are you sure you want to delete this comment? This action can not be undone."}
        open={showDelete}
        onCancel={() => setShowDelete(false)}
        footer={[]}
        width={500}
        type="delete-alt"
        className={"study-overview-authoring-delete-modal"}
        style={{ zIndex: 9 }}
        getContainer={() => document.getElementById(containerId)}
      >
        <div className="modal-content">
          <RJCommentItem
            index={-1}
            handleEdit={() => {}}
            handleDelete={() => {}}
            showMenu={false}
            comment={deleteComment}
          />
        </div>
        <div className="action-container">
          <PrimeButton
            onClick={() => {
              setShowDelete(false)
              setDeleteComment(null)
            }}
          >
            Cancel
          </PrimeButton>
          <PrimeButton
            onClick={() => onDeleteComment()}
            danger
            type="primary"
          >
            Delete
          </PrimeButton>
        </div>
      </Modal>
    </div>
  )
}

export default RJCommentList
